import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { Trash } from 'iconsax-react';
import { HFilledTextField } from '@ui/components/common/TextField';
const EditableField = forwardRef(({ label, value, placeholder, onConfirmValue, onValueChange, onDiscardForm, onResetValue, editableFieldSx, inputSx, containerSx, bg = 'light' }, ref) => {
    const theme = useTheme();
    const [isFocused, setIsFocused] = useState(false);
    const [editedValue, setEditedValue] = useState(value ?? '');
    // Reset edited value if parent changes it
    useEffect(() => {
        setEditedValue(value ?? '');
    }, [value]);
    const hasUnsavedChanges = editedValue !== value;
    const showControls = isFocused || hasUnsavedChanges;
    return (_jsxs(Box, { className: 'step-title-container', width: '100%', sx: containerSx, children: [label && (_jsx(Typography, { variant: 'caption', color: theme.palette.grey[900], children: label })), _jsxs(Box, { className: 'text-field-container', display: 'flex', alignItems: 'center', children: [_jsx(HFilledTextField, { ref: ref, size: 'medium', bg: bg, placeholder: placeholder, fullWidth: true, value: editedValue, onFocus: () => setIsFocused(true), onBlur: () => {
                            setIsFocused(false);
                            onConfirmValue?.(editedValue);
                        }, onChange: (e) => {
                            const newVal = e.target.value;
                            setEditedValue(newVal);
                            onValueChange?.(newVal);
                        }, sx: {
                            ...theme.typography.h5,
                            ...editableFieldSx
                        }, slotProps: {
                            input: {
                                sx: {
                                    background: 'transparent',
                                    // border: showControls
                                    //   ? `1px solid ${alpha(theme.palette.common.white, 0.5)}`
                                    //   : '1px solid transparent',
                                    height: 53,
                                    '& input': {
                                        ...theme.typography.body2,
                                        fontWeight: 400,
                                        color: theme.palette.text.primary,
                                        // padding: showControls ? '0px 0px 0px 6px' : '0px',
                                        padding: '0px',
                                        '&::placeholder': {
                                            ...theme.typography.body2,
                                            opacity: 1,
                                            color: theme.palette.text.disabled
                                        }
                                    },
                                    ...inputSx
                                },
                                startAdornment: (_jsx(Box, { height: '100%' }))
                            }
                        } }), onDiscardForm && (_jsx(IconButton, { color: 'default', size: 'medium', sx: { border: 'none' }, onClick: onDiscardForm, children: _jsx(Trash, { size: '24', color: theme.palette.error.light }) }))] })] }));
});
export default EditableField;
